export const styles = theme => ({
    formBox: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        padding: "2rem",
        margin: "2rem 0"
    },
    errorText: {
        color: "red"
    },
    website: {
        // honeypot
        display: "none"
    }
});
